import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect } from 'react';
import { MessageStatus } from "../../../../../shared/api";
import { useAppDispatch, useAppSelector } from "../../../../../shared/model";
import { getMessageFile } from "../../../../../shared/lib";
import { getImageThunk } from "../../../model";
import { ImgPreviewType } from "../../../../../shared/types/settings";
import { ymPushClickAttachView } from "../../../../../shared/analytics";
import { AttachLabel } from "../../../../../shared/config";
import { selectChatCofig } from "../../../../settings/model";
export var useImageView = function useImageView(_ref) {
  var message = _ref.message,
    setImgUrl = _ref.setImgUrl,
    setImgPreview = _ref.setImgPreview;
  var dispatch = useAppDispatch();
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var isRefresh = message.messageStatus === MessageStatus.refresh;
  var _message$message = message.message,
    imageSettings = _message$message.imageSettings,
    fileUrl = _message$message.fileUrl,
    filePreviewUrl = _message$message.filePreviewUrl;
  var isLoading = message.messageStatus === MessageStatus.download || message.messageStatus === MessageStatus.sent;
  var urls = getMessageFile(message);
  var fetchImageRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, resultAction;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = filePreviewUrl ? urls === null || urls === void 0 ? void 0 : urls.filePreviewUrl : urls === null || urls === void 0 ? void 0 : urls.fileUrl;
            if (url) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", undefined);
          case 3:
            _context.next = 5;
            return dispatch(getImageThunk({
              url: url,
              message: message
            }));
          case 5:
            resultAction = _context.sent;
            return _context.abrupt("return", resultAction.payload);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchImageRequest() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCLick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$fetchImageRequ, newFileUrl, configImageSettings;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isRefresh) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            ymPushClickAttachView(AttachLabel.IMAGE, zoneType);

            // Загружаем фото из базы
            if (!(urls !== null && urls !== void 0 && urls.filePreviewUrl && urls !== null && urls !== void 0 && urls.fileUrl && (!fileUrl || !filePreviewUrl))) {
              _context2.next = 12;
              break;
            }
            _context2.next = 6;
            return fetchImageRequest();
          case 6:
            _yield$fetchImageRequ = _context2.sent;
            newFileUrl = _yield$fetchImageRequ.srcFile;
            configImageSettings = _yield$fetchImageRequ.imageSettings;
            setImgUrl({
              fileUrl: fileUrl || !filePreviewUrl && newFileUrl,
              filePreviewUrl: filePreviewUrl || filePreviewUrl && newFileUrl,
              imageSettings: imageSettings || configImageSettings
            });
            _context2.next = 13;
            break;
          case 12:
            // Сохранение url изображения в сторе
            setImgUrl({
              fileUrl: fileUrl,
              filePreviewUrl: filePreviewUrl,
              imageSettings: imageSettings
            });
          case 13:
            // Открытие превью изображения если есть превью
            if (filePreviewUrl) {
              setImgPreview({
                isImgPreviewOpen: true,
                type: ImgPreviewType.show
              });
            }
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleCLick() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (message.messageStatus === MessageStatus.download) {
      void fetchImageRequest();
    }
  }, []);
  return {
    filePreviewUrl: filePreviewUrl,
    isLoading: isLoading,
    isRefresh: isRefresh,
    handleCLick: handleCLick
  };
};